<script>
  import { HorizontalBar } from 'vue-chartjs'
  import chartRendererMixin from '@/components/elements/charts/chartRendererMixin'

  export default {
    extends: HorizontalBar,
    mixins: [chartRendererMixin]
  }
</script>



// WEBPACK FOOTER //
// HorizontalBarChart.vue?8272e8f8